import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'targetGroup',
    standalone: false
})
export class TargetGroupPipe implements PipeTransform {
  transform(value: string): string {
    
    if (typeof value !== 'string' || !value) {
      return value || ''; 
    }
    switch (value.toUpperCase()) {
      case 'LOYALTYMEMBER':
        return 'Loyalty Member';
      default:
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
  }
}